exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-file-input~.custom-file-label[data-v-4d6b4fd6]:after{content:\"Examinar\"}", ""]);

// exports
